"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = require("./Checkbox.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Checkbox =
/*#__PURE__*/
function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).call(this, props));

    _this.onClick = function (event) {
      event.persist();
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          checked = _this$props.checked;
      var isChecked = _this.state.isChecked;

      _this.setState({
        isChecked: !isChecked
      }, function () {
        if (!disabled) {
          if (onChange) onChange(event, !checked);
        }
      });
    };

    _this.renderCheckbox = function () {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          disabled = _this$props2.disabled,
          color = _this$props2.color,
          id = _this$props2.id;
      var isChecked = _this.state.isChecked;
      return _react.default.createElement(_Checkbox.StyledCheckbox, {
        value: !disabled && isChecked,
        disabled: disabled,
        color: color,
        name: name,
        id: id || name,
        checked: !disabled && isChecked,
        onChange: _this.onClick
      });
    };

    _this.state = {
      isChecked: false
    };
    return _this;
  }

  _createClass(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var checked = this.props.checked;
      this.setState({
        isChecked: checked
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var isChecked = this.state.isChecked;

      if (nextProps.checked !== isChecked) {
        this.setState({
          isChecked: !isChecked
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          id = _this$props3.id,
          name = _this$props3.name,
          leftToRight = _this$props3.leftToRight,
          disabled = _this$props3.disabled,
          children = _this$props3.children,
          error = _this$props3.error,
          errorMessage = _this$props3.errorMessage,
          align = _this$props3.align;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Checkbox.StyledCheckboxContainer, {
        align: align
      }, leftToRight ? _react.default.createElement(_react.default.Fragment, null, this.renderCheckbox(), _react.default.createElement(_Checkbox.StyledLabel, {
        disabled: disabled,
        htmlFor: id || name
      }, children)) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Checkbox.StyledLabel, {
        disabled: disabled,
        htmlFor: id || name
      }, children), this.renderCheckbox())), error && _react.default.createElement(_Checkbox.StyledErrorMessage, null, errorMessage));
    }
  }]);

  return Checkbox;
}(_react.Component);
/**
 * Definition of default values for component props
 */


exports.Checkbox = Checkbox;
Checkbox.defaultProps = {
  children: undefined,
  color: '#000000',
  disabled: false,
  checked: false,
  error: false,
  errorMessage: 'This field is required',
  className: undefined,
  id: undefined,
  leftToRight: true,
  align: "left",
  onChange: function onChange() {}
};
/**
 * Definition of types for component props
 */

Checkbox.propTypes = {
  /** Children nodes */
  children: _propTypes.default.node,

  /** The icon color property */
  color: _propTypes.default.string,

  /** Whether it is disbled or not */
  disabled: _propTypes.default.bool,

  /** Whether it is checked or not */
  checked: _propTypes.default.bool,

  /** Whether to show the error message */
  error: _propTypes.default.bool,

  /** Text for the error message */
  errorMessage: _propTypes.default.string,

  /** Input name */
  name: _propTypes.default.string.isRequired,

  /** Component className */
  className: _propTypes.default.string,

  /** Component id */
  id: _propTypes.default.string,

  /** checkbox and label order */
  leftToRight: _propTypes.default.bool,

  /** checkbox alignment */
  align: _propTypes.default.oneOf(['left', 'center', 'right']),

  /** onChange event handler */
  onChange: _propTypes.default.func
};